import React from 'react';

import useExpectations from 'hooks/reports/utilization/package-utilization/useExpectations';

import ExpectationsTable from '../Components/ExpectationsTable';

const Table = (): JSX.Element => {
  const { data, isLoading, isSuccess, isError } = useExpectations({});

  return (
    <ExpectationsTable
      data={data?.data ?? []}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
    />
  );
};

export default Table;
